import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  copy() {
    const el = document.getElementById(this.targetValue)
    if (!el) return

    const content = el.value || el.textContent
    if (!content) return

    navigator.clipboard.writeText(content).then(() => {
      const original = this.element.innerHTML
      this.element.innerHTML = '<i class="fas fa-check mr-1"></i>Copied!'
      setTimeout(() => { this.element.innerHTML = original }, 2000)
    })
  }
}
